//Dev
//const baseUrl: string = 'https://dev01.firstcon.de/api/v2'

//Lokal
//const baseUrl: string = 'https://localhost:44340/api/v2'
const baseUrl: string =import.meta.env.VITE_API_URL;
const gkUrl: string =import.meta.env.VITE_GK_URL;
//export const personalDataUrl: string = gkUrl+'/Identity/Account/Manage'
// export const sendHelpUrl: string = gkUrl+'/api/ApiData/sendHelpRequest'
export const gkUrlEx: string = gkUrl
export const sendHelpUrl: string = baseUrl+'/CustomerPortal/SendHelpRequest'
// export const changePasswordUrl: string = gkUrl+'/api/ApiData/changePasswordRequest'
export const changePasswordUrl: string = baseUrl+'/CustomerPortal/ChangePassword'
// export const changeEmailUrl: string = gkUrl+'/api/ApiData/changeEmailRequest'
export const changeEmailUrl: string = baseUrl+'/CustomerPortal/ChangeEmail'
export const authUrl: string = baseUrl + '/CustomerPortal/Login'
export const contractUrl: string = baseUrl + '/CustomerPortal/ContractInfo'
export const adjustPricePerMonthUrl: string =
  baseUrl + '/CustomerPortal/AdjustPricePerMonth'
export const paymentMethodUrl: string = baseUrl + '/CustomerPortal/AlterBankAccountData'
export const addContractUrl: string = baseUrl + '/CustomerPortal/AddContractForCustomerPortal'
export const meterReadingUrl: string = baseUrl + '/MeterReading'
export const newMeterUrl: string = baseUrl +'/CustomerPortal/PostIsThereANewMeterNumber'
export const forgotPassword: string = baseUrl + '/CustomerPortal/ForgotPassword'